import { ModuleWithProviders, NgModule } from '@angular/core';

import { StoreService } from './store.service';

@NgModule({
	imports: [],
	declarations: [],
	providers: [StoreService],
	exports: []
})
export class StoreServiceModule {
	

	public static forRoot(): ModuleWithProviders<StoreServiceModule> {
		return {
			ngModule: StoreServiceModule,
			providers: [StoreService]
		};
	}
}
